import { getMartData } from "api/ApiCalls"
import { applyFetcherOptions } from "helpers/martHelpers"
import { type MartFetcherOptions } from "types/ApiTypes"
import type { IServerSideGetRowsRequest } from "@tokenterminal/ui/DataTable"

const DATASET_TABLE = `fundraises`

const PLAIN_SSRM_REQUEST: IServerSideGetRowsRequest = {
  startRow: 0,
  endRow: 100,
  valueCols: [],
  pivotCols: [],
  rowGroupCols: [],
  pivotMode: false,
  groupKeys: [],
  filterModel: {},
  sortModel: [],
}

const DEFAULT_SSRM_REQUEST: IServerSideGetRowsRequest = {
  ...PLAIN_SSRM_REQUEST,
  sortModel: [
    {
      sort: "desc",
      colId: "round_date",
    },
  ],
}

enum RoundType {
  PreSeed = "Pre-seed",
  Seed = "Seed",
  SeriesA = "Series A",
  SeriesB = "Series B",
  SeriesC = "Series C",
  Strategic = "Strategic",
  Unknown = "Unknown",
}

type FundraisesDataBQ = {
  project_dbt_tag: string | null
  project_name: string | null
  project_id: string | null
  round_id: number | null
  round_type: RoundType
  round_date: { value: Date | null } | null
  round_value: number | null
  project_main_category: string | null
  project_additional_categories: string | null
  lead_investors: string | null
  investors: string | null
  brief_description_of_project: string | null
  source: string | null
  project_website: string | null
  project_twitter: string | null
}

export async function getFundraisesData<T = Array<FundraisesDataBQ>>(
  body: IServerSideGetRowsRequest = DEFAULT_SSRM_REQUEST,
  opts?: MartFetcherOptions
) {
  if (opts) {
    applyFetcherOptions(body, opts)
  }

  const { data } = await getMartData<T>(DATASET_TABLE, body)

  return data
}
